@for (category of views(); track category?.i ?? 0) {
  <section
    class="catalog-panel-view"
    [animate.enter]="category ? 'catalog-panel-view-enter' : ''"
    animate.leave="catalog-panel-view-leave"
    [inert]="!$last"
  >
    <div class="catalog-panel-head">
      @if (category) {
        <button
          class="catalog-panel-head-btn catalog-panel-back"
          type="button"
          [attr.aria-label]="'global.back' | translate"
          (click)="back()"
        >
          <tc-icon name="arrow-left" />
        </button>
      } @else {
        <!-- keeps the title centred, as in the views with a back button -->
        <span class="catalog-panel-head-btn"></span>
      }

      <h2 class="catalog-panel-title">
        {{ category ? category.n : ('header.catalog' | translate) }}
      </h2>

      <button
        class="catalog-panel-head-btn catalog-panel-close"
        type="button"
        [attr.aria-label]="'catalog_panel.close' | translate"
        (click)="closed.emit()"
      >
        <tc-icon name="close" />
      </button>
    </div>

    @if (category) {
      <a
        class="catalog-panel-all"
        [routerLink]="['/', category.s]"
        routerLinkWithLang
        (click)="closed.emit()"
      >
        <span class="catalog-panel-all-label">
          {{ 'catalog_panel.show_all' | translate: { name: category.n } }}
        </span>
        <tc-icon class="catalog-panel-all-icon" name="arrow-left" />
      </a>
    }

    <div class="catalog-panel-body">
      <ul class="catalog-panel-grid">
        @for (item of category ? category.c : categoryService.categories(); track item.i) {
          <li>
            @if (item.c.length) {
              <a
                class="catalog-panel-card"
                [href]="getHref(item)"
                (click)="open($event, item)"
              >
                <img
                  class="catalog-panel-card-img"
                  [src]="getImage(item.m)"
                  [alt]="item.n"
                  width="160"
                  height="80"
                  loading="lazy"
                >
                <span class="catalog-panel-card-foot">
                  <span class="catalog-panel-card-name">{{ item.n }}</span>
                  <tc-icon class="catalog-panel-card-chevron" name="chevron-right" />
                </span>
              </a>
            } @else {
              <a
                class="catalog-panel-card"
                [routerLink]="['/', item.s]"
                routerLinkWithLang
                (click)="closed.emit()"
              >
                <img
                  class="catalog-panel-card-img"
                  [src]="getImage(item.m)"
                  [alt]="item.n"
                  width="160"
                  height="80"
                  loading="lazy"
                >
                <span class="catalog-panel-card-foot">
                  <span class="catalog-panel-card-name">{{ item.n }}</span>
                </span>
              </a>
            }
          </li>
        }
      </ul>
    </div>
  </section>
}
